import { instance } from 'store/utils';
import { types } from './types';
import { downloadFile, downloadRequestHeaders } from 'store/forms/utils';
import { message } from 'antd';

export const react_path = process.env.REACT_APP_PROCESS_APP

export const getFormData = taskId => dispatch => {
    dispatch({ type: types.GET_FORM_DATA_APP.START });
    instance
      .get(`/app/rest/task-forms/${taskId}/with-vars`)
      .then(response => {
        dispatch({ type: types.GET_FORM_DATA_APP.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_FORM_DATA_APP.ERROR });
      });
  };

  export const fetchProcessSAYT = searchKey => dispatch => {
    dispatch({ type: types.FETCH_PROCESS_SAYT.START });
    instance
    .get(`/app/rest/findSAYT?searchKey=` + searchKey)
      .then(response => {
        dispatch({ type: types.FETCH_PROCESS_SAYT.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.FETCH_PROCESS_SAYT.ERROR });
      });
  };

  // export const getActions = procInstId => dispatch => {
  //   dispatch({ type: types.GET_ACTIONS.START });
  //   instance
  //   .get(`/app/rest/${procInstId}/actions`)
  //     .then(response => {
  //       dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
  //     })
  //     .catch(error => {
  //       console.log(error, 'error');
  //       dispatch({ type: types.GET_ACTIONS.ERROR });
  //     });
  // };

  export const getActions = procInstId => dispatch => {
    dispatch({ type: types.GET_ACTIONS.START });
    
    return instance
        .get(`/app/rest/${procInstId}/actions`)
        .then(response => {
            dispatch({ type: types.GET_ACTIONS.SUCCESS, payload: response.data });
            return response.data; 
        })
        .catch(error => {
            console.log(error, 'error');
            dispatch({ type: types.GET_ACTIONS.ERROR });
            throw error; 
        });
};
  
  export const getTaskData = taskId => dispatch => {
    dispatch({ type: types.GET_TASK_DATA.START });
    instance
      .get(`/app/rest/tasks/${taskId}`)
      .then(response => {
        dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_TASK_DATA.ERROR });
      });
  };
  
  export const fetchProcInstancesDetailed = data => dispatch => {
    dispatch({ type: types.GET_PROCESS_INSTANCES_APP.START });
    instance
      .post(`/app/rest/process-instances-apptrack`, data)
      .then(response => {
        const res = response.data.data
        const results = Object.keys(res).map(key => ({
          id: key,
          ...res[key]
        }))
        dispatch({
          type: types.GET_PROCESS_INSTANCES_APP.SUCCESS,
          payload: {
            variables: results
          },
        });
        // if(!params.isViewMode){
        // dispatch(getFormData(params.taskId));
        // }
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_INSTANCES_APP.ERROR });
      });
  };

  export const clearApptrack = () => dispatch => {
    dispatch({ type: types.CLEAR_APPTRACK.SUCCESS });
  };

  export const clearSayt = () => dispatch => {
    dispatch({ type: types.CLEAR_SAYT });
  };

  export const navigateToView = (navigate, processInstanceId) => {
    navigate(`/apptrack/${processInstanceId}`);
  };

  export const cancelProcessInstance = (procInstId) => dispatch => {
    console.log("bike sto cancel stin klish");
    dispatch({ type: types.CANCEL_PROCESS.START });
    instance.get(`/app/rest/cancel-process-instance/${procInstId}`)
        .then(response => {
            dispatch({ type: types.CANCEL_PROCESS.SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: types.CANCEL_PROCESS.ERROR, error });
        });
};

  export const getDetails = (processInstanceId) => {
    return  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
      .then((response) => {
        return response.data.variablesIndexed;
      });
  }

  export const getApptrackDetails = (processInstanceId) => dispatch => {
    dispatch({ type: types.GET_APPTRACK_DETAILS.START });

    instance
      .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
      .then((response) => {
        // console.log("RESPONSE",response.data);
        dispatch({
          type: types.GET_APPTRACK_DETAILS.SUCCESS,
          payload: {
            activeTaskId: response.data.activeTaskId,
            activeTaskName: response.data.activeTaskName,
            businessKey: response.data.businessKey,
            localTaskVariables: response.data.localTaskVariables,
            variablesIndexed: response.data.variablesIndexed,
            contentItems: response.data.contentItems,
            comments: response.data.comments,
          },
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_APPTRACK_DETAILS.ERROR });

        console.log(error, 'error');
      });
  }

  export const getOffersHistory = () => dispatch => {
    dispatch({ type: types.GET_OFFERS_HISTORY.START });

    instance
      .get(`/app/rest/offers/uploads`)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.GET_OFFERS_HISTORY.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_OFFERS_HISTORY.ERROR });

        console.log(error, 'error');
      });
  };

  export const uploadOffers = ({file, callback}) => dispatch => {
    dispatch({ type: types.UPLOAD_OFFERS.START });

    instance
      .post(`/app/rest/offers/upload`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_OFFERS.SUCCESS
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_OFFERS.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

  export const downloadUploadedFilev2 = (fileInfo) => dispatch => {
    message.loading("Αναμονή λήψης αρχείου");
    dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.START });
    instance
      .get(`/app/rest/downloadFile?fileId=${fileInfo?.id}`, { responseType: "blob" })
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = fileInfo?.filename;
        link.click();
        dispatch({
          type: types.DOWNLOAD_UPLOADED_FILE.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };

  export const getActiveOffers = (infrprov = '') => dispatch => {
    dispatch({ type: types.GET_ACTIVE_OFFERS.START });

    instance
      .get(`/app/rest/offers/getAll${infrprov ? `/${infrprov}` : ''}`)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.GET_ACTIVE_OFFERS.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ACTIVE_OFFERS.ERROR });

        console.log(error, 'error');
      });
  }

  export const clearActiveOffers = () => dispatch => {
    dispatch({type: types.CLEAR_ACTIVE_OFFERS.SUCCESS, payload: {}})
  }

  export const openUploadOffersModal = (open) => dispatch => {
    dispatch({type: types.OPEN_UPLOAD_OFFERS_MODAL.SUCCESS, payload: open})
  }
  export const openUploadProviderModal = (open) => dispatch => {
    dispatch({type: types.OPEN_UPLOAD_PROVIDER_MODAL.SUCCESS, payload: open})
  }
  export const setSelectedOffersFileFlag = (selected) => dispatch => {
    dispatch({type: types.SET_SELECTED_OFFERS_FILE.SUCCESS, payload: selected})
  }
  export const setSelectedProviderFileFlag = (selected) => dispatch => {
    dispatch({type: types.SET_SELECTED_PROVIDER_FILE.SUCCESS, payload: selected})
  }

  export const setApptrackLoading = () => dispatch => {
    dispatch({type: types.SET_APPTRACK_LOADING})
  }

  export const getAllTaskNames = () => dispatch => {
    dispatch({ type: types.GET_ALL_TASK_NAMES.START });

    instance
      .get(`/app/rest/all-task-names`)
      .then(response => {
        dispatch({
          type: types.GET_ALL_TASK_NAMES.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });

        console.log(error, 'error');
      });
  }

  export const getFilterOptions = () => dispatch => {
    dispatch({ type: types.GET_FILTER_OPTIONS.START });

    instance
      .get(`/app/rest/get-filter-options`)
      .then(response => {
        dispatch({
          type: types.GET_FILTER_OPTIONS.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_FILTER_OPTIONS.ERROR });

        console.log(error, 'error');
      });
  }

  export const addComment = (id, data) => dispatch => {
    const payload = {
      id: "",
      message: data,
      created: "",
      createdBy: "",
    };
  
    return instance
      .post(`/app/rest/process-instances/${id}/comments`, payload)
      .then(response => {
        console.log("RESPONSE:", response.data);
        // dispatch({
        //   type: types.GET_ALL_TASK_NAMES.SUCCESS,
        //   payload: response.data,
        // });
      })
      .catch(error => {
        // dispatch({ type: types.GET_ALL_TASK_NAMES.ERROR });
        console.log(error, 'error');
      });
  };

  export const uploadReserveRedeeem = ({file, callback}) => dispatch => {
    dispatch({ type: types.UPLOAD_PROVIDER.START });
    instance
      .put(`/app/rest/providers/mass-reserve`, file)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.UPLOAD_PROVIDER.SUCCESS
        });
        callback(true);
      })
      .catch(error => {
        dispatch({ type: types.UPLOAD_PROVIDER.ERROR });
        callback(false);
        console.log(error, 'error');
      });
  };

  export const getProviderHistory = () => dispatch => {
    dispatch({ type: types.GET_PROVIDER_HISTORY.START });

    instance
      .get(`/app/rest/providers/uploads`)
      .then(response => {
        console.log(response.data);
        dispatch({
          type: types.GET_PROVIDER_HISTORY.SUCCESS,
          payload: response.data,
        });
      })
      .catch(error => {
        dispatch({ type: types.GET_PROVIDER_HISTORY.ERROR });
        console.log(error, 'error');
      });
  };

  export const getProviderHistoryExcelDetail = (fileInfo,params) => dispatch => {
    message.loading("Αναμονή λήψης αρχείου");
    const status = params;
    console.log({status});
    dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.START });
    instance
      .post(`/app/rest/providers/details?fieldId=${fileInfo?.id}`, {status},{ responseType: "blob" })
      .then(response => {
        //create hidden anchor and click behind the scenes to trigger download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(response.data);
        link.download = fileInfo?.filename;
        link.click();
        dispatch({
          type: types.GET_PROVIDER_HISTORY_DETAILS.SUCCESS,
        });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROVIDER_HISTORY_DETAILS.ERROR });
        // message.error("Σφάλμα κατά τη λήψη του αρχείου");
      });
  };

  
